// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./+not-found.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/+not-found.tsx"); } },
  "./[lang]/[collection].tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/[collection].tsx"); } },
  "./[lang]/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/_layout.tsx"); } },
  "./[lang]/account.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/account.tsx"); } },
  "./[lang]/index.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/index.tsx"); } },
  "./[lang]/saved.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/saved.tsx"); } },
  "./[lang]/tours/[id].tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/tours/[id].tsx"); } },
  "./[lang]/tours/index.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/[lang]/tours/index.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/_layout.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/home/runner/work/events-app-expo/events-app-expo/apps/miami/src/app/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;